import styled from 'styled-components';
import {
  QuestionItem,
  TitleText
} from 'components/treeOfContent/QuestionTreeNode/QuestionTreeNode.styled';

export const LearningObjectiveItem = styled(QuestionItem)``;

export const ItemTitle = styled(TitleText)``;
